var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-404"},[_c('ContentLayout'),_c('div',{staticClass:"content"},[_c('h1',[_vm._v(_vm._s(_vm.$t('errors.notFound')))]),_c('button',{staticClass:"btn btn-outline-success",attrs:{"type":"button"},on:{"click":function($event){return _vm.backHome()}}},[_vm._v(" "+_vm._s(_vm.$t('errors.backToHomePage'))+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }